export default "__VITE_ASSET__ClZzZXUh__"